<template>
    <div class="ui-enter">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'ui-enter',
    methods: {
        isFile (url) {
            url = new URL(url, location.origin);
            return url.pathname.split('/').pop().indexOf('.') > 0;
        },

        isEmail(url) {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(url).toLowerCase());
        },
    },
    mounted() {
        setTimeout(() => {
            const links = this.$el.querySelectorAll('a');
            links.forEach(el => {
                const href = el.getAttribute('href');
                if (href.charAt(0) === '/' || href.indexOf(window.globals.home_url) !== -1) {
                    el.addEventListener('click', (e) => {
                        e.preventDefault();
                        const link = href.replace(window.globals.home_url, '');
                        this.$router.push(link);
                    });

                }
                else if (this.isFile(href)) {
                    el.setAttribute('download', '');
                } else if (this.isEmail(href)) {
                    el.setAttribute('target', '_blank');
                } 
            });
 
        }, 100);
    }
}

</script>

<style lang="scss">
.history-footnotes-footer {
    padding-top: 30px;
    padding-right: 80px;
    margin-top: 100px;
    border-top: 1px solid black;
    width: fit-content;
}

.ui-enter {
    // margin: var(--padding) 0;

    // font-size: var(--medium-size);
    font-size: 107%;
    line-height: 1.423;

    &.center-content {
        max-width: var(--content-width);
        padding: 0 var(--padding-x2);
        margin: 0 auto;
    }

    p,
    h1,
    h2,
    h3,
    h4,
    ul,
    ol,
    blockquote {
        margin: 0 0 var(--padding-x2);
    }

    // h1:not(:first-child),h2:not(:first-child),h4:not(:first-child) {
    //     margin-top: var(--padding-x2);
    // }

    h1,
    h2,
    h3,
    h4 {
        font-weight: normal;
    }

    .wp-caption {
        max-width: 100%;
    }

    a {
        text-decoration: underline;
        text-decoration-color: var(--blue);
        text-decoration-skip-ink: none;
        text-decoration-thickness: 0.5rem;
        text-underline-offset: 0.1rem;
    }

    h1 {
        font-size: var(--title-size);
        text-align: center;
        padding: var(--padding-x2) 0;
    }

    h2 {
        font-size: var(--large-size);
        // margin-bottom: calc(var(--padding) * 1.5);
        // margin-bottom: 1em;
    }

    h3 {
        font-size: var(--large-size);
        // margin-bottom: 1em;
        // font-weight: bold;
        text-align: center;
    }

    h4 {
        font-size: var(--large-size);
        margin-bottom: 0;
    }

    ol,
    ul {
        // margin-left: 2rem;

        li {
            margin: 0;
        }
    }

    ul {
        list-style-type: none;
        list-style-position: none;
        list-style-image: none;
        margin-left: .5rem;

        li {
            margin-left: 1.5rem;
            position: relative;

            &::before {
                content: '·';
                position: absolute;
                left: -1.5rem;
            }
        }
    }

    ol {
        list-style-type: none;
        list-style-position: none;
        list-style-image: none;
        margin-left: 1.5rem;

        li {
            margin-left: 1.5rem;
            position: relative;
            list-style: decimal;
        }
    }

    blockquote {
        position: relative;
        padding: var(--padding-x2) 0;
        // font-size: var(--large-size);
        display: block;

        p {
            margin: 0;
        }

        em {
            font-size: var(--tiny-size);
            display: block;
            margin: var(--padding-25) 0 0;
        }
    }


    img {
        display: block;
        width: auto;
        max-height: 80rem;
        height: auto;
    }

    .wp-caption,
    .embed-image {
        display: block;
        width: auto !important;
        height: auto;

        img {
            margin-bottom: var(--padding);
        }

        .wp-caption-text {
            font-size: var(--small-size);
        }
    }

    img {
        max-width: 100%;
        height: auto;
        display: block;
        margin: var(--padding-x4) auto;
    }

    iframe {
        max-width: 100%;
        display: block;
    }

    .embed-video {
        display: block;
        margin: var(--padding) 0;
        width: auto !important;
        position: relative;

        &::before {
            display: block;
            content: '';
            padding-top: 56.2%;
        }

        iframe {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
        }
    }
}

// @media only screen and (max-width: 780px) {
//     .ui-enter {

//         p,
//         h1,h2,h3,h4,
//         ul, ol, blockquote {
//             margin: 0 0 var(--padding);
//         }

//         img {
//             margin: 0 0 var(--padding) 0;
//             max-height: unset;
//         }

//     }
// }
</style>